const tournamentConfig = {
  updateInterval: 100000,
  spinAndGoUpdateInterval: 60000,
};

export default tournamentConfig;
